/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApplicationAnswerDto
 */
export interface ApplicationAnswerDto {
  /**
   *
   * @type {string}
   * @memberof ApplicationAnswerDto
   */
  question: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationAnswerDto
   */
  answer: string;
}

/**
 * Check if a given object implements the ApplicationAnswerDto interface.
 */
export function instanceOfApplicationAnswerDto(
  value: object,
): value is ApplicationAnswerDto {
  if (!("question" in value) || value["question"] === undefined) return false;
  if (!("answer" in value) || value["answer"] === undefined) return false;
  return true;
}

export function ApplicationAnswerDtoFromJSON(json: any): ApplicationAnswerDto {
  return ApplicationAnswerDtoFromJSONTyped(json, false);
}

export function ApplicationAnswerDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApplicationAnswerDto {
  if (json == null) {
    return json;
  }
  return {
    question: json["question"],
    answer: json["answer"],
  };
}

export function ApplicationAnswerDtoToJSON(json: any): ApplicationAnswerDto {
  return ApplicationAnswerDtoToJSONTyped(json, false);
}

export function ApplicationAnswerDtoToJSONTyped(
  value?: ApplicationAnswerDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    question: value["question"],
    answer: value["answer"],
  };
}
